import React, { FC, useEffect, useState } from 'react'
import { StyledUserSetting, StyledWrapper } from './UserSetting.styled'
import { SettingScreen } from './SettingScreen/SettingScreen'
import { MainScreen } from './MainScreen/MainScreen'
import { MyAccountContext } from './hooks/useMyAccountContext'
import { useInitMyAccount } from './hooks/useInitMyAccount'
import { EmailBanner } from './components/EmailBanner'
import { UserSettingsSlideToast } from '../content/UserSettingsSlideToast/UserSettingsSlideToast'
import {
    AddToCartEvent,
    AppState,
    BaseClientConfig,
    ExtendedAccessEvent,
    Product,
    SubscribeWithGoogleEvent,
    UserAuthEvents,
} from '@news-mono/web-common'
import { Logger } from 'typescript-log'
import {
    BeginLoadingEvent,
    EndLoadingEvent,
} from 'react-ssr-data-loader/dist/cjs/events'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import { useProduct } from '../__product'

export type UserSettingEvent =
    | UserAuthEvents
    | BeginLoadingEvent
    | EndLoadingEvent
    | ExtendedAccessEvent
    | SubscribeWithGoogleEvent
    | AddToCartEvent
export interface UserSettingProps {
    onEvent: (event: UserSettingEvent) => void
    config: BaseClientConfig
    log: Logger
}

export const UserSetting: FC<UserSettingProps> = ({ onEvent, log, config }) => {
    const { isLoggedIn, isLoading } = useSelector(
        (state: AppState) => state.authentication,
    )
    const [loggedIn, setLoggedIn] = useState<boolean>(true)
    const product = useProduct()
    const ctx = useInitMyAccount()

    useEffect(() => {
        if (!isLoading && !isLoggedIn) {
            setLoggedIn(false)
        }
    }, [isLoading, isLoggedIn])

    function onDismissToast() {
        ctx.setToast({ ...ctx.toast, show: false })
    }
    if (!loggedIn) {
        return <Redirect to={'/'} />
    }
    return (
        <MyAccountContext.Provider value={ctx}>
            <StyledWrapper>
                {product === Product.TheNightly && <EmailBanner />}
                <StyledUserSetting>
                    <SettingScreen />
                    <MainScreen
                        onEvent={onEvent}
                        log={log}
                        config={config}
                        screen={ctx.screen}
                        show={ctx.isScreenSelected}
                    />
                </StyledUserSetting>
                <UserSettingsSlideToast
                    text={ctx.toast.text}
                    type={ctx.toast.type}
                    show={ctx.toast.show}
                    onClose={onDismissToast}
                />
            </StyledWrapper>
        </MyAccountContext.Provider>
    )
}
